<kui-modal *ngIf="showRemindersModal" [isOpen]="showRemindersModal" (isOpenChange)="isRemindersModalOpen()" type="info">
  <kp-modal-reminders (closeClicked)="handlePermissionsFromModal($event)"></kp-modal-reminders>
</kui-modal>

<kp-detail-view-action
  title="Reminders"
  infoText="A nudge at just the right time can make all the difference. Purposeful will send you notifications to help you take
  action."
  [primaryIconUrl]="setRemindersOn ? primaryIcon : null"
  [showInfo]="setRemindersOn && notifications?.[0] == null"
  (primaryIconClicked)="primaryIconClick()">
  <ng-container *ngIf="!setRemindersOn" info>
    <kp-permission-dialog
      *ngIf="showPflNotificationDialog"
      [canEnable]="true"
      description="You haven't enabled web notifications on this browser."
      (enableButtonClicked)="toggleWebReminders(true)"></kp-permission-dialog>
    <kp-permission-dialog
      *ngIf="showBrowserNotificationDialog"
      description="Notifications from Purposeful are currently blocked on this browser. Please allow them in your browser settings to receive web reminders."></kp-permission-dialog>
    <kp-permission-dialog
      *ngIf="showBrowserUnsupported"
      description="The browser you are using does not support web notifications. To receive web reminders, try updating your browser or using a different one."></kp-permission-dialog>
  </ng-container>
</kp-detail-view-action>
<ng-container *ngIf="setRemindersOn">
  <kp-action-reminder
    *ngFor="let notification of notifications"
    [cardId]="card.id"
    [notification]="notification"
    (notificationDeleted)="handleNotificationDeletion($event)"
    (notificationEdited)="handlePrimaryIconChange()"
    (notificationUpdated)="handleNotificationSave()"></kp-action-reminder>
</ng-container>
